module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_19.dot-9911ecb21630502d0eff8957996849ff.svg";